// CC-02 (B2) · varias autoridades por país (AT S3 §11.3.1).
//
// `GET /administracion/autoridades` sigue respondiendo UNA FILA POR PAÍS (la de su autoridad
// predeterminada, para no romper a quien ya la lee) y desde CC-02 trae además
// `autoridades[]`: todas las del país, la predeterminada primero. Las pantallas de
// Autoridades y plazos y de Autoridad competente pintan una fila por AUTORIDAD; este módulo
// las aplana en un solo sitio.
//
// Una fila de país sin `autoridades[]` (un servidor anterior a CC-02) se trata como su única
// autoridad, predeterminada: la pantalla se ve igual que antes.
import type { RespuestaDelApi } from '../tipos';

/** Una fila por autoridad: los datos del país (calendario, zona) con los de la autoridad encima. */
export function filasPorAutoridad(paises: RespuestaDelApi[]): RespuestaDelApi[] {
  return paises.flatMap((pais): RespuestaDelApi[] => {
    const autoridades: RespuestaDelApi[] = Array.isArray(pais.autoridades) ? pais.autoridades : [];
    if (autoridades.length === 0) {
      return [{ ...pais, id: String(pais.pais), es_predeterminada: true, activa: true, fila_del_pais: pais }];
    }
    return autoridades.map((autoridad) => ({
      ...pais,
      ...autoridad,
      // Las celdas y el formulario leen `autoridad` como el nombre (así lo trae la fila del país).
      autoridad: autoridad.nombre,
      id: `${pais.pais}-${autoridad.codigo}`,
      fila_del_pais: pais,
    }));
  });
}

/** La autoridad predeterminada de un país, para los textos («hereda la firma de SAG»). */
export function predeterminadaDe(pais: RespuestaDelApi | undefined): RespuestaDelApi | undefined {
  if (!pais) return undefined;
  const autoridades: RespuestaDelApi[] = Array.isArray(pais.autoridades) ? pais.autoridades : [];
  return autoridades.find((a) => a.es_predeterminada) ?? { ...pais, nombre: pais.autoridad };
}

/** El código de una autoridad: de 2 a 20 letras, dígitos o guion bajo (RN-72). */
export const CODIGO_DE_AUTORIDAD = /^[A-Z0-9_]{2,20}$/;
